import Grid from '@mui/material/Grid'
import React from 'react'
import { Outlet } from 'react-router-dom'

const OrdersScreen = () => {
    return (
        <Grid flexDirection={'column'}>
            <Outlet />
        </Grid>
    )
}

export default React.memo(OrdersScreen)
